import _ from 'lodash';

// Bonifier la fonction isEmpty de lodash afin de supporter les primitives.

export default function isEmpty(value) {
  if (_.isNumber(value)) {
    return _.isNaN(value);
  } else if (_.isBoolean(value) || _.isDate(value)) {
    return false;
  }
  return _.isEmpty(value);
}
